module.exports = __webpack_public_path__ + "img/center.0642ca06.svg";